//////////////////
// IMPORTS
//////////////////
import * as React from "react";
import Radium from "radium";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";

//////////////////
// TYPES
//////////////////
interface IULProps {
  items: React.ReactNode[];
  style?: React.CSSProperties;
  itemStyle?: React.CSSProperties;
}

interface IOLProps extends IULProps {
  alpha?: boolean;
}

//////////////////
// STYLES
//////////////////
const listStyles: React.CSSProperties = {
  paddingLeft: spacing.xlg,
};

const itemStyle: React.CSSProperties = {
  position: "relative",
  marginBottom: spacing.std,
};

const bulletStyle: React.CSSProperties = {
  position: "absolute",
  left: 0,
  top: 0,
  float: "left",
  color: colors.blueDusk.standard,
};

const itemTextStyle: React.CSSProperties = {
  marginLeft: 30,
};

//////////////////
// COMPONENT
//////////////////
@Radium
export class UL extends React.PureComponent<IULProps, {}> {
  public render() {
    return (
      <ul style={{ ...listStyles, ...this.props.style }}>
        {this.props.items.map((item, i) => (
          <li style={{ ...itemStyle, ...this.props.itemStyle }} key={i}>
            <div style={bulletStyle}>•</div>
            <div style={itemTextStyle}>{item}</div>
          </li>
        ))}
      </ul>
    );
  }
}

@Radium
export class OL extends React.PureComponent<IOLProps, {}> {
  public render() {
    return (
      <ol style={{ ...listStyles, ...this.props.style }}>
        {this.props.items.map((item, i) => (
          <li style={{ ...itemStyle, ...this.props.itemStyle }} key={i}>
            <div style={bulletStyle}>{this.props.alpha ? String.fromCharCode(97 + i) : i}.</div>
            <div style={itemTextStyle}>{item}</div>
          </li>
        ))}
      </ol>
    );
  }
}
